const initTradeApplicationForm = (section) => {
  if (section.dataset.tradeApplicationInitialized === 'true') {
    return;
  }

  const form = section.querySelector('form');
  const configScript = section.querySelector('[data-trade-application-config]');

  if (!form || !configScript) {
    return;
  }

  let config = {};

  try {
    config = JSON.parse(configScript.textContent || '{}');
  } catch (_error) {
    config = {};
  }

  section.dataset.tradeApplicationInitialized = 'true';

  const endpoint = section.dataset.endpoint;
  const customerEmail = section.dataset.customerEmail || '';
  const customerIdInput = section.querySelector('[data-trade-customer-id]');
  const customerId = customerIdInput?.value || '';
  const status = section.querySelector('[data-trade-status]');
  const privacy = section.querySelector('[data-trade-privacy]');
  const submit = form.querySelector('button[type="submit"]');
  const accountStatus = section.querySelector('[data-trade-account-status]');
  const accountGate = section.querySelector('[data-trade-account-gate]');
  const accountComponent = section.querySelector('[data-trade-account-component]');
  const submissionGroups = section.querySelectorAll('[data-trade-submission-fields]');
  const accountHelper = section.querySelector('[data-trade-account-helper]');
  let accountSheetOpened = false;

  const setStatus = (message, state = '') => {
    status.textContent = message || '';
    status.dataset.state = state;
  };

  const currentType = () => form.querySelector('input[name="request_type"]:checked')?.value || 'trade_access';

  const syncOptionHighlight = (radioName) => {
    form.querySelectorAll(`input[name="${radioName}"]`).forEach((input) => {
      input.closest('.trade-application__option')?.classList.toggle('is-selected', input.checked);
    });
  };

  const syncConditionalFields = () => {
    const type = currentType();
    const requiresAccount = type === 'trade_access' && !customerEmail;
    const canSubmit = !requiresAccount;

    privacy.textContent = config.privacy?.[type] || '';

    if (accountHelper) {
      accountHelper.hidden = type !== 'trade_access' || requiresAccount;
    }

    if (accountGate) {
      accountGate.hidden = !requiresAccount;
    }

    if (accountStatus) {
      accountStatus.value = type === 'project_quote'
        ? 'not_required'
        : (customerId ? 'existing_account' : 'login_required');
    }

    if (customerIdInput) {
      customerIdInput.value = type === 'project_quote' ? '' : customerId;
    }

    submissionGroups.forEach((group) => {
      group.hidden = !canSubmit;
      group.querySelectorAll('input, select, textarea, button').forEach((input) => {
        input.disabled = !canSubmit;
      });
    });

    section.querySelectorAll('[data-trade-conditional]').forEach((panel) => {
      const panelVisible = panel.dataset.tradeConditional === type && canSubmit;
      panel.hidden = !panelVisible;

      panel.querySelectorAll('input, select, textarea').forEach((input) => {
        input.required = panelVisible;
        input.disabled = !panelVisible;
      });
    });
  };

  form.addEventListener('change', (event) => {
    if (event.target.name === 'request_type') {
      syncOptionHighlight('request_type');
      syncConditionalFields();
    }

    if (event.target.name === 'tax_exempt_request') {
      syncOptionHighlight('tax_exempt_request');
    }
  });

  if (accountComponent) {
    accountComponent.addEventListener('open', () => {
      accountSheetOpened = true;
    });

    accountComponent.addEventListener('close', () => {
      if (!accountSheetOpened || window.Shopify?.designMode) return;

      accountSheetOpened = false;
      window.location.reload();
    });
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    setStatus('', '');

    if (!endpoint) {
      setStatus(config.messages?.missingEndpoint, 'error');
      return;
    }

    const type = currentType();
    const email = form.elements.work_email.value.trim();

    if (type === 'trade_access' && !customerEmail) {
      setStatus(config.messages?.loginRequired, 'error');
      return;
    }

    if (type === 'trade_access' && customerEmail && email.toLowerCase() !== customerEmail.toLowerCase()) {
      setStatus(config.messages?.emailMismatch, 'error');
      form.elements.work_email.focus();
      return;
    }

    if (!form.reportValidity()) return;

    submit.disabled = true;
    setStatus(config.messages?.loading, '');

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(Object.fromEntries(new FormData(form).entries()))
      });

      if (!response.ok) throw new Error('Request failed');

      let result = {};
      try {
        result = await response.json();
      } catch (_error) {
        result = { ok: true };
      }

      if (result && result.ok === false) {
        setStatus(result.message || config.messages?.error, 'error');
        return;
      }

      setStatus(config.messages?.success, 'success');
    } catch (_error) {
      setStatus(config.messages?.error, 'error');
    } finally {
      submit.disabled = false;
    }
  });

  syncOptionHighlight('request_type');
  syncOptionHighlight('tax_exempt_request');
  syncConditionalFields();
};

const initTradeApplicationForms = () => {
  document.querySelectorAll('[data-section-type="trade-application-form"]').forEach(initTradeApplicationForm);
};

const initBefloTheme = () => {
  initTradeApplicationForms();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBefloTheme, { once: true });
} else {
  initBefloTheme();
}

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-section-type="trade-application-form"]').forEach(initTradeApplicationForm);
});
